import { Button } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { Fragment, useState } from "react";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  leftButton: {
    marginRight: "auto",
  },
});

interface IInstructionItem {
  text: React.ReactNode;
  linkUrl?: string;
  linkLabel?: string;
}

interface ITemplateDownloadInvoice {
  buttonLabel: string;
  title: string;
  instructions: IInstructionItem[];
}

const TemplateUploadInvoiceButton = ({
  buttonLabel,
  title,
  instructions
}: ITemplateDownloadInvoice) => {
  const [open, setOpen] = useState<boolean>(false);
  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label={buttonLabel}
        onClick={handleOpenDialog}
        className={classes.leftButton}
      />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent dividers>
          {instructions.map((item, index) => (
            <>
              <Typography key={`text-${index}`} gutterBottom>
                {item.text}
              </Typography>
              {item.linkUrl && (
                <>
                  <Typography key={`link-${index}`} gutterBottom>
                    <Link href={item.linkUrl}>
                      {item.linkLabel || "Download"}
                    </Link>
                  </Typography>
                  <br/>
                </>
              )}
            </>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default TemplateUploadInvoiceButton;
